$(document).ready(function() {

  $('#finishDateInvoice').datepicker({ format: 'MM yyyy', autoclose: true, minViewMode: 'months' });
  $('#startDateInvoice').datepicker({ format: 'MM yyyy', autoclose: true, minViewMode: 'months' });

  $('#download-freelancer-invoices').click(function (event) {
    event.preventDefault();
    let files = getInvoiceIds();
    if (files) {
      window.location.href = '/files/getArchive?file_ids=' + files
    }
  });

  function getInvoiceIds() {
    let ids = [];
    $('input[class="select-invoice"]:checked').each(function (indx, invoice) {
      if ($(invoice).parent().parent().children().last().children('a').data('file-id')) {
        ids.push($(this).data('id'));
      }
    });
    return ids.join(',');
  }

  $('#select-all-invoices').change(function (event) {
    event.preventDefault();
    $('.select-invoice').prop('checked', this.checked);
  });

  $('#invoices-filters-toggler').on('click', function () {
    $('#invoices-filter').toggle('display')
  })

  $(".new-sf-downloader").on("click", (e) => {
    e.preventDefault();
    const token = localStorage.getItem("accessToken");
    fetch($(e.delegateTarget).data('link'), {
      headers: {"Authorization": "Bearer " + token},
    })
        .then(resp => resp.blob())
        .then(blob => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.style.display = 'none';
          a.href = url;
          a.download = 'sf.pdf';
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
        })
  });
});
